import { CompanyService } from "./../../../services/catalogs/CompanyService";
import React from "react";
import { CompanyDetail } from "../../../components/Pages/Catalogs/Company/CompanyDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCompanyDto } from "../../../dtos/catalogs/company/CreateCompanyDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CostCalculationMethods } from "../../../enums/CostCalculationMethods";
import { NFLookupCompany } from "../../../components/Shared/NewForms/NFLookupCompany";
import CompanyList from "../../../components/Pages/Catalogs/Company/CompanyList";

export const Company: IAppEntity = {
  entityType: "catalog",
  title: "Company",
  pluralTitle: "Companies",
  apiUrl: "companies",
  apiEnum: ReferenceTypes.CatalogCompany,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CompanyDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CompanyList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCompany, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },

  getDataService() {
    return new CompanyService(this.apiUrl);
  },
  getEmptyModel(): CreateCompanyDto {
    return {
      name: "",
      tin: "",
      legalForm: 0,
      registrationDate: new Date(),
      legalAddress: "",
      actualAddress: "",
      phoneNumber: "",
      email: "",
      isEmailValid: false,
      prefix: "",
      costCalculationMethod: CostCalculationMethods.Average,
    };
  },
};
